export default __webpack_public_path__ + "static/media/blog05.bfaa1c1e.png";